import { useInfiniteQuery as _useInfiniteQuery, useIsFetching as _useIsFetching, useIsMutating as _useIsMutating, useMutation as _useMutation, useQueries as _useQueries, useQuery as _useQuery, } from '@tanstack/react-query';
import { queryContext } from './client';
export const useQuery = (queryKey, queryFn, options) => _useQuery(queryKey, queryFn, {
    context: queryContext,
    ...options,
});
export const useMutation = (mutationFn, options) => _useMutation(options?.mutationFn ?? mutationFn, {
    context: queryContext,
    ...options,
});
export const useInfiniteQuery = (options) => _useInfiniteQuery(options);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useQueries = ({ queries, context, }) => _useQueries({ queries, context: context ?? queryContext });
export const useIsMutating = (mutationKey, filters, options) => _useIsMutating(mutationKey, filters, { context: queryContext, ...options });
export const useIsFetching = (mutationKey, filters, options) => _useIsFetching(mutationKey, filters, { context: queryContext, ...options });
